// extracted by mini-css-extract-plugin
export var icon = "_4y-1";
export var subtext = "_4y-0";